import { Link } from "react-router-dom";

export function Navbar() {
  return (
    <header className="absolute inset-x-0 top-0 z-20" data-testid="navbar">
      <nav
        className="mx-auto flex max-w-6xl items-center justify-between px-5 py-5 sm:px-8"
        aria-label="Primary"
      >
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo-link">
          <img src="/bootrise-logo.png" alt="BootRise" className="h-11 w-auto sm:h-12" />
          <span className="hidden items-center gap-1.5 rounded-full border border-border bg-white/60 px-2.5 py-1 text-xs font-medium text-ink-muted md:inline-flex">
            <img src="/lint_hero.webp" alt="" className="h-4 w-4 object-contain" />
            featuring Lint
          </span>
        </Link>
        <div className="flex items-center gap-1 sm:gap-2">
          <a
            href="#meet-lint"
            className="hidden rounded-full px-3 py-2 text-sm font-medium text-navy/75 transition-colors hover:text-navy sm:inline-block"
            data-testid="nav-meet-lint-link"
          >
            Meet Lint
          </a>
          <Link
            to="/demo"
            className="rounded-full px-3 py-2 text-sm font-medium text-navy/75 transition-colors hover:text-navy"
            data-testid="nav-demo-link"
          >
            Explore demo
          </Link>
          <a
            href="#waitlist"
            className="rounded-full bg-navy px-4 py-2 text-sm font-semibold text-cream transition-colors hover:bg-brand"
            data-testid="nav-waitlist-link"
          >
            Book a demo
          </a>
        </div>
      </nav>
    </header>
  );
}
